/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyDeptForm from './CompanyDeptForm';




  /**
   * The CourseStandardCreateForm model module.
   * @module course_standard/model/CourseStandardCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CourseStandardCreateForm</code>.
   * @alias module:course_standard/model/CourseStandardCreateForm
   * @class
   * @param name {String} 班课名称
   * @param courseId {Integer} 课程id
   */
  var exports = function(name, courseId) {
    var _this = this;

    _this['name'] = name;
    _this['courseId'] = courseId;





  };

  /**
   * Constructs a <code>CourseStandardCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/CourseStandardCreateForm} obj Optional instance to populate.
   * @return {module:course_standard/model/CourseStandardCreateForm} The populated <code>CourseStandardCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'courseId')) {
        obj['courseId'] = ApiClient.convertToType(data['courseId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'version')) {
        obj['version'] = ApiClient.convertToType(data['version'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'targetId')) {
        obj['targetId'] = ApiClient.convertToType(data['targetId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'companyDeptList')) {
        obj['companyDeptList'] = ApiClient.convertToType(data['companyDeptList'], [CompanyDeptForm]);
      }
    }
    return obj;
  }

  /**
   * 班课名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 课程id
   * @member {Integer} courseId
   */
  exports.prototype['courseId'] = undefined;
  /**
   * 版本号
   * @member {String} version
   */
  exports.prototype['version'] = undefined;
  /**
   * 摘要
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 编号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 课程目标id
   * @member {Integer} targetId
   */
  exports.prototype['targetId'] = undefined;
  /**
   * 负责课程标准的学校-分院
   * @member {Array.<module:course_standard/model/CompanyDeptForm>} companyDeptList
   */
  exports.prototype['companyDeptList'] = undefined;



  export default exports;
;


